import { render, staticRenderFns } from "./MarketingAutomationFormPanelSms.vue?vue&type=template&id=6b662594&scoped=true"
import script from "./MarketingAutomationFormPanelSms.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormPanelSms.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormPanelSms.vue?vue&type=style&index=0&id=6b662594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b662594",
  null
  
)

export default component.exports